import ArtistVideoPlayer from "../../utils/ArtistVideoPlayer";
import React from "react";
import { useGalleryVideosForPreview } from "@/api/hooks/useGalleryVideosForPreview";
import { useArtistProfilePic } from "@/api/hooks/useArtistDisplayName";

const VideoPlaceholder = ({ className }: { className?: string }) => (
  <div
    className={`bg-[#2C2C2E] flex items-center justify-center rounded-lg ${className}`}
    aria-hidden
  >
    <div className="w-12 h-12 rounded-full border-2 border-[#8E8E93] border-dashed opacity-50" />
  </div>
);

const ArtistEconomyVideos = () => {
  const { slots } = useGalleryVideosForPreview("economy");
  const profilePic = useArtistProfilePic();

  return (
    <div className="mt-20 px-4 w-screen">
      <div className="grid grid-cols-2 max-sm:grid-cols-1 gap-4">
        {slots.map((slot) =>
          slot.type === "video" ? (
            <div
              key={slot.id}
              className="relative w-full h-[400px] max-md:h-[300px] border border-zinc-800 rounded-lg overflow-hidden pointer-events-none"
            >
              <ArtistVideoPlayer
                source={slot.source}
                isThumbnail
                profile_pic={profilePic ?? ""}
                containerClassName="relative w-full h-full"
                imageClassName="object-cover"
                overlayClassName="absolute top-0 left-0 w-full h-full bg-black/40 flex items-center justify-center"
                durationClassName="absolute bottom-4 right-4 font-bold text-lg p-4 text-white"
                titleClassName="absolute top-2 left-2 text-lg p-4 text-white"
              />
            </div>
          ) : (
            <div
              key={`ph-${slot.index}`}
              className="relative w-full h-[400px] max-md:h-[300px] border border-zinc-800 rounded-lg overflow-hidden pointer-events-none flex items-center justify-center"
            >
              <VideoPlaceholder className="w-full h-full rounded-lg" />
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default ArtistEconomyVideos;
